module.exports = __webpack_public_path__ + "img/style-1.7c649daa.png";